import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { MemberInsightPostsMutateType } from "~/domains";

type RequestDataType = {
  businessSectionId: string;
};

const request = ({ businessSectionId }: RequestDataType) => {
  return new ApiClient()
    .post<MemberInsightPostsMutateType>(
      `/api/managers/business_sections/${businessSectionId}/archiveds`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersBusinessSectionsArchivedsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  MemberInsightPostsMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
